<template>
  <div class="main-container">
    <transition name="fadeout">
      <div v-show="show" class="spinner">
        <spinner />
        <span class="hint font-bold">{{ $t('loading') }}</span>
      </div>
    </transition>
  </div>
</template>

<script>
import { useLoaderStore } from '../store/loader';
import Spinner from './Spinner.vue';
export default {
  components: { Spinner },
  data() {
    return {
      show: false,
      store: useLoaderStore()
    };
  },
  /* created() {
    const store = useLoaderStore();
    store.$subscribe((mutation, state) => {
      if (mutation.events.key == "tasks") {
        if (state.tasks > 0) { */
  watch: {
    'store.tasks': function (tasks) {
      if (tasks > 0) {
        this.show = true;
      } else if (tasks == 0) {
        setTimeout(
          function () {
            this.show = false;
          }.bind(this),
          100 // delay
        );
      }
      /*
      }
    });
  },
       */
    }
  },
  beforeUnmount() {
    if (this.timoutHandle) {
      clearTimeout(this.timoutHandle);
    }
  }
};
</script>

<style scoped>
@reference "@/assets/css/tailwind.css";
.main-container {
  /* Grundlegende mobile Einstellungen: zentriert */
  @apply fixed w-auto h-auto left-1/2 bottom-1/2 transform -translate-x-1/2 -translate-y-1/2 flex justify-center;
  z-index: 9999;

  /* Einstellungen für Desktop und größere Tablets: unten links */
  @apply md:left-2 md:bottom-6 md:transform-none;
}
.spinner {
  @apply flex items-center sm:ml-6 bg-gray-50 rounded-lg bg-black/80 border border-gray-100 z-50 px-2 py-1;
}
/*.spinner-backdrop {
  @apply fixed inset-0 bg-gray-500 bg-black/50 backdrop-filter backdrop-blur-xs flex items-center justify-center z-40;
}*/
.hint {
  @apply ml-4 italic;
}
</style>
